import { useParams } from 'react-router-dom'

import {
  LoadingContainer,
  Form,
  Input,
  Bar,
  Panels,
  Select,
  Modal,
  LegacyPage,
  Model,
  StateCodeSelect,
  CountryCodeSelect,
} from 'peach/components'

import {
  useInternalGetContactForBorrower,
  useInternalUpdateContactForBorrower,
} from 'core/types'

const PersonContact = () => {
  const { companyId, personId, contactId } = useParams<{
    companyId?: string
    personId?: string
    contactId?: string
  }>()

  const {
    data: contact,
    isLoading,
    error,
  } = useInternalGetContactForBorrower({
    companyId,
    personId,
    contactId,
  })

  const { mutateAsync: updateContact } = useInternalUpdateContactForBorrower({
    companyId,
    personId,
    contactId,
  })

  const types = ['phone', 'email', 'address', 'whatsApp', 'fbMessenger']
  const labels = ['personal', 'home', 'work']
  const statuses = ['primary', 'secondary', 'additional', 'archived']

  const editContact = (
    <Modal
      initialValue={contact}
      onSubmit={async (_values, diff) => {
        await updateContact(diff)
      }}
      render={({ value }) => (
        <>
          <Select formKey='status' options={statuses} />
          <Select formKey='label' options={labels} />
          <Select formKey='contactType' options={types} />
          {value.contactType === 'address' ? (
            <>
              <Form.Provider formKey='address'>
                <Input formKey='addressLine1' />
                <Input formKey='addressLine2' />
                <Input formKey='city' />
                <Input formKey='countyOrRegion' />
                <StateCodeSelect formKey='state' />
                <Input formKey='postalCode' />
                <CountryCodeSelect formKey='country' />
              </Form.Provider>
            </>
          ) : (
            <Input formKey='value' />
          )}
          <Select boolean formKey='verified' />
          <Select boolean formKey='valid' />
        </>
      )}
      title='Edit Contact'
      trigger
    />
  )

  const header = <Bar right={editContact} title='Contact' />

  return (
    <Panels header={header}>
      <LoadingContainer error={error} isLoading={isLoading}>
        <LegacyPage>
          <Model.Viewer json={contact} title='Contact' />
        </LegacyPage>
      </LoadingContainer>
    </Panels>
  )
}

export default PersonContact
